import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { Spinner, CollapseBlock } from '../../../../../common/index.jsx';
import { useGetInterestQuery } from '../../../../../../redux/services/fij_applications.jsx';

const FijInterestDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: interest, isLoading } = useGetInterestQuery(id);

  const formatValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return value;
  };

  const pageTitle =
    t('Údaje poskytnuté záujemcom o FRI prax') +
    ': ' +
    formatValue(interest?.internal_job_name);

  useEffect(() => {
    document.title = pageTitle + ' - FRI.prax';
  }, [pageTitle]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS title={pageTitle} backUrl={-1} backUrlTooltip={t('Späť')} />

      <div style={{ margin: '10px' }}>
        {!interest ? (
          <div>{t('Záznam sa nenašiel.')}</div>
        ) : (
          <CollapseBlock collapsible title={t('Základné informácie')}>
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td>
                    <b>{t('Študent')}</b>
                  </td>
                  <td>{formatValue(interest.student_full_name)}</td>
                </tr>
                <tr>
                  <td>
                    <b>{t('Študijná skupina')}</b>
                  </td>
                  <td>{formatValue(interest.school_group)}</td>
                </tr>
                <tr>
                  <td>
                    <b>{t('E-mail')}</b>
                  </td>
                  <td>{formatValue(interest.mail)}</td>
                </tr>
                <tr>
                  <td>
                    <b>{t('Motivačný text')}</b>
                  </td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>
                    {formatValue(interest.motivation_text)}
                  </td>
                </tr>
              </tbody>
            </table>
          </CollapseBlock>
        )}
      </div>
    </>
  );
};

export default FijInterestDetailPage;
